// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Course Detail Page Styles */
.course-detail-container {
    background-color: #f8f9fa;
    min-height: 100vh;
    padding: 2rem 0;
  }
  
  /* Course Header */
  .course-header {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    margin-bottom: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .course-title {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.5rem;
  }
  
  .course-category {
    color: #6c757d;
    font-size: 0.9rem;
  }
  
  .course-actions .btn {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
  }
  
  .course-detail-image {
    width: 100%;
    height: 300px;
    object-fit: cover;
    border-radius: 8px;
  }
  
  /* Course Content */
  .course-content {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  /* Course Tabs */
  .course-tabs {
    border-bottom: 2px solid #f8f9fa;
    margin-bottom: 2rem;
  }
  
  .course-tab {
    background: none;
    border: none;
    padding: 1rem 1.5rem;
    color: #6c757d;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 3px solid transparent;
    margin-right: 1rem;
  }
  
  .course-tab:hover {
    color: #333;
  }
  
  .course-tab.active {
    color: #295478;
    border-bottom-color: #295478;
  }
  
  /* Section Titles */
  .section-title {
    font-size: 1.3rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1.5rem;
  }
  
  /* Learning Outcomes */
  .learning-outcome {
    display: flex;
    align-items: flex-start;
    font-size: 0.95rem;
    color: #555;
    line-height: 1.5;
  }
  
  /* Course Curriculum */
  .modules-list {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .module-item {
    border-bottom: 1px solid #e9ecef;
  }
  
  .module-item:last-child {
    border-bottom: none;
  }
  
  .module-header {
    padding: 1rem 1.5rem;
    background-color: #f8f9fa;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background-color 0.3s ease;
  }
  
  .module-header:hover {
    background-color: #e9ecef;
  }
  
  .module-title {
    font-weight: 500;
    color: #333;
  }
  
  .module-lessons {
    background-color: white;
  }
  
  .lesson-item {
    padding: 0.75rem 1.5rem;
    border-bottom: 1px solid #f8f9fa;
    transition: background-color 0.3s ease;
  }
  
  .lesson-item:hover {
    background-color: #f8f9fa;
  }
  
  .lesson-item:last-child {
    border-bottom: none;
  }
  
  .lesson-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .lesson-icon {
    color: #b8860b;
    font-size: 0.9rem;
  }
  
  .lesson-title {
    color: #555;
    font-size: 0.9rem;
  }
  
  .lesson-meta {
    display: flex;
    align-items: center;
  }
  
  .lesson-duration {
    color: #6c757d;
    font-size: 0.8rem;
    font-weight: 500;
  }
  
  /* Course Sidebar */
  .course-sidebar {
    position: sticky;
    top: 2rem;
  }
  
  .sidebar-card {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
  
  .sidebar-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1rem;
  }
  
  .sidebar-subtitle {
    font-size: 0.9rem;
    font-weight: 500;
    color: #6c757d;
    margin-bottom: 1rem;
  }
  
  /* Progress Info */
  .progress-info {
    font-size: 0.9rem;
    color: #6c757d;
  }
  
  .progress {
    height: 8px;
    background-color: #e9ecef;
    border-radius: 4px;
  }
  
  .progress-bar {
    background-color: #14b4c5;
    border-radius: 4px;
  }
  
  /* Buttons */
  .btn-primary {
    background-color: #295478;
    border-color: #1e3a5f;
  }
  
  .btn-primary:hover {
    background-color: #152a42;
    border-color: #152a42;
  }
  
  .btn-warning {
    background-color: #4fbe6c;
    border-color: #4fbe6c;
    color: white;
  }
  
  .btn-warning:hover {
    background-color: #4fbe6c;
    border-color: #4fbe6c;
    color: white;
  }
  
  /* Enrollment Info */
  .enrollment-info {
    background-color: #f8f9fa;
    padding: 0.75rem;
    border-radius: 6px;
    font-size: 0.85rem;
  }
  
  /* Course Stats */
  .course-stat {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    font-size: 0.9rem;
    color: #6c757d;
  }
  
  .course-stat i {
    color: #4fbe6c;
    width: 20px;
  }
  
  /* Instructor */
  .instructor-info {
    display: flex;
    align-items: center;
  }
  
  .instructor-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .instructor-name {
    font-weight: 500;
    color: #295478;
  }
  
  /* Material List */
  .material-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .material-item {
    display: flex;
    align-items: flex-start;
    padding: 0.5rem 0;
    font-size: 0.9rem;
    color: #555;
    line-height: 1.4;
  }
  
  /* Announcements */
  .announcements-content {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 2rem;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .course-detail-container {
      padding: 1rem 0;
    }
  
    .course-header,
    .course-content {
      padding: 1.5rem;
      margin-bottom: 1rem;
    }
  
    .course-title {
      font-size: 1.5rem;
    }
  
    .course-actions {
      margin-top: 1rem;
    }
  
    .course-actions .btn {
      font-size: 0.8rem;
      padding: 0.4rem 0.8rem;
    }
  
    .course-detail-image {
      height: 200px;
    }
  
    .course-tabs {
      overflow-x: auto;
      white-space: nowrap;
    }
  
    .course-tab {
      padding: 0.75rem 1rem;
      margin-right: 0.5rem;
    }
  
    .module-header,
    .lesson-item {
      padding: 1rem;
    }
  
    .lesson-content {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }
  
    .sidebar-card {
      padding: 1rem;
    }
  }
  
  @media (max-width: 576px) {
    .learning-outcome {
      margin-bottom: 1rem;
    }
  
    .lesson-title {
      font-size: 0.85rem;
    }
  
    .lesson-duration {
      font-size: 0.75rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/course-detail.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;EACjB;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;EAC1C;;EAEA,gBAAgB;EAChB;IACE,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,4BAA4B;EAC9B;;EAEA,mBAAmB;EACnB;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;EACvB;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,gCAAgC;IAChC,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,YAAY;EACZ;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;EACd;;EAEA,oBAAoB;EACpB;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA,eAAe;EACf;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,kBAAkB;EAClB;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;IACjB;;IAEA;;MAEE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,qBAAqB;MACrB,oBAAoB;IACtB;;IAEA;;MAEE,aAAa;IACf;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,WAAW;IACb;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":["/* Course Detail Page Styles */\n.course-detail-container {\n    background-color: #f8f9fa;\n    min-height: 100vh;\n    padding: 2rem 0;\n  }\n  \n  /* Course Header */\n  .course-header {\n    background: white;\n    border-radius: 12px;\n    padding: 2rem;\n    margin-bottom: 2rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .course-title {\n    font-size: 1.8rem;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 0.5rem;\n  }\n  \n  .course-category {\n    color: #6c757d;\n    font-size: 0.9rem;\n  }\n  \n  .course-actions .btn {\n    font-size: 0.9rem;\n    padding: 0.5rem 1rem;\n  }\n  \n  .course-detail-image {\n    width: 100%;\n    height: 300px;\n    object-fit: cover;\n    border-radius: 8px;\n  }\n  \n  /* Course Content */\n  .course-content {\n    background: white;\n    border-radius: 12px;\n    padding: 2rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Course Tabs */\n  .course-tabs {\n    border-bottom: 2px solid #f8f9fa;\n    margin-bottom: 2rem;\n  }\n  \n  .course-tab {\n    background: none;\n    border: none;\n    padding: 1rem 1.5rem;\n    color: #6c757d;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-bottom: 3px solid transparent;\n    margin-right: 1rem;\n  }\n  \n  .course-tab:hover {\n    color: #333;\n  }\n  \n  .course-tab.active {\n    color: #295478;\n    border-bottom-color: #295478;\n  }\n  \n  /* Section Titles */\n  .section-title {\n    font-size: 1.3rem;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 1.5rem;\n  }\n  \n  /* Learning Outcomes */\n  .learning-outcome {\n    display: flex;\n    align-items: flex-start;\n    font-size: 0.95rem;\n    color: #555;\n    line-height: 1.5;\n  }\n  \n  /* Course Curriculum */\n  .modules-list {\n    border: 1px solid #e9ecef;\n    border-radius: 8px;\n    overflow: hidden;\n  }\n  \n  .module-item {\n    border-bottom: 1px solid #e9ecef;\n  }\n  \n  .module-item:last-child {\n    border-bottom: none;\n  }\n  \n  .module-header {\n    padding: 1rem 1.5rem;\n    background-color: #f8f9fa;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    transition: background-color 0.3s ease;\n  }\n  \n  .module-header:hover {\n    background-color: #e9ecef;\n  }\n  \n  .module-title {\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .module-lessons {\n    background-color: white;\n  }\n  \n  .lesson-item {\n    padding: 0.75rem 1.5rem;\n    border-bottom: 1px solid #f8f9fa;\n    transition: background-color 0.3s ease;\n  }\n  \n  .lesson-item:hover {\n    background-color: #f8f9fa;\n  }\n  \n  .lesson-item:last-child {\n    border-bottom: none;\n  }\n  \n  .lesson-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .lesson-icon {\n    color: #b8860b;\n    font-size: 0.9rem;\n  }\n  \n  .lesson-title {\n    color: #555;\n    font-size: 0.9rem;\n  }\n  \n  .lesson-meta {\n    display: flex;\n    align-items: center;\n  }\n  \n  .lesson-duration {\n    color: #6c757d;\n    font-size: 0.8rem;\n    font-weight: 500;\n  }\n  \n  /* Course Sidebar */\n  .course-sidebar {\n    position: sticky;\n    top: 2rem;\n  }\n  \n  .sidebar-card {\n    background: white;\n    border: 1px solid #e9ecef;\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  }\n  \n  .sidebar-title {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 1rem;\n  }\n  \n  .sidebar-subtitle {\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: #6c757d;\n    margin-bottom: 1rem;\n  }\n  \n  /* Progress Info */\n  .progress-info {\n    font-size: 0.9rem;\n    color: #6c757d;\n  }\n  \n  .progress {\n    height: 8px;\n    background-color: #e9ecef;\n    border-radius: 4px;\n  }\n  \n  .progress-bar {\n    background-color: #14b4c5;\n    border-radius: 4px;\n  }\n  \n  /* Buttons */\n  .btn-primary {\n    background-color: #295478;\n    border-color: #1e3a5f;\n  }\n  \n  .btn-primary:hover {\n    background-color: #152a42;\n    border-color: #152a42;\n  }\n  \n  .btn-warning {\n    background-color: #4fbe6c;\n    border-color: #4fbe6c;\n    color: white;\n  }\n  \n  .btn-warning:hover {\n    background-color: #4fbe6c;\n    border-color: #4fbe6c;\n    color: white;\n  }\n  \n  /* Enrollment Info */\n  .enrollment-info {\n    background-color: #f8f9fa;\n    padding: 0.75rem;\n    border-radius: 6px;\n    font-size: 0.85rem;\n  }\n  \n  /* Course Stats */\n  .course-stat {\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 0;\n    font-size: 0.9rem;\n    color: #6c757d;\n  }\n  \n  .course-stat i {\n    color: #4fbe6c;\n    width: 20px;\n  }\n  \n  /* Instructor */\n  .instructor-info {\n    display: flex;\n    align-items: center;\n  }\n  \n  .instructor-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  \n  .instructor-name {\n    font-weight: 500;\n    color: #295478;\n  }\n  \n  /* Material List */\n  .material-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .material-item {\n    display: flex;\n    align-items: flex-start;\n    padding: 0.5rem 0;\n    font-size: 0.9rem;\n    color: #555;\n    line-height: 1.4;\n  }\n  \n  /* Announcements */\n  .announcements-content {\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    padding: 2rem;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .course-detail-container {\n      padding: 1rem 0;\n    }\n  \n    .course-header,\n    .course-content {\n      padding: 1.5rem;\n      margin-bottom: 1rem;\n    }\n  \n    .course-title {\n      font-size: 1.5rem;\n    }\n  \n    .course-actions {\n      margin-top: 1rem;\n    }\n  \n    .course-actions .btn {\n      font-size: 0.8rem;\n      padding: 0.4rem 0.8rem;\n    }\n  \n    .course-detail-image {\n      height: 200px;\n    }\n  \n    .course-tabs {\n      overflow-x: auto;\n      white-space: nowrap;\n    }\n  \n    .course-tab {\n      padding: 0.75rem 1rem;\n      margin-right: 0.5rem;\n    }\n  \n    .module-header,\n    .lesson-item {\n      padding: 1rem;\n    }\n  \n    .lesson-content {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.5rem;\n    }\n  \n    .sidebar-card {\n      padding: 1rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .learning-outcome {\n      margin-bottom: 1rem;\n    }\n  \n    .lesson-title {\n      font-size: 0.85rem;\n    }\n  \n    .lesson-duration {\n      font-size: 0.75rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
